export default function Concatenation({ items, connective }) {
  return items
    .flatMap((item, i, items) => [
      i === items.length - 1 ? ` ${connective} ` : ", ",
      item,
    ])
    .slice(1);
}
